<div [ngClass]="getBadgeClasses()">
  <div
    *ngIf="checkDigit() !== 'no-digit'; else noDigitBadge"
    [ngClass]="getDigitClasses()"
  >
    {{ getFormattedDigit() }}
  </div>
  <ng-template #noDigitBadge> </ng-template>
</div>
